"use strict";
// component-wasThisHelpful.js
(function ($) {
    function getCurrencies() {
        var currClass = '.js-selectedCurrency';
        var currencies = {}, selectedCurrency = $(currClass).find('select option:selected').text(), convertedCurrency = $(currClass).find('select option:not(:selected)').text(), selectedCurrencyAmount = '';
        // Check if the selected currency is EUR and if it is, select the Euro input amount
        if ((selectedCurrency == 'Euro') || (selectedCurrency == 'EUR')) {
            selectedCurrency = 'EUR';
            selectedCurrencyAmount = $('.js-selectedCurrencyAmountEur').find('input').val();
        }
        // Otherwise selected the other Currency input amount
        else if ((selectedCurrency != 'Euro') || (selectedCurrency != 'EUR')) {
            selectedCurrency = $(currClass).find('select option:selected').text();
            selectedCurrencyAmount = $('.js-selectedCurrencyAmountOther').find('input').val();
        }
        // Currency array
        currencies['selectedCurrency'] = selectedCurrency;
        currencies['selectedCurrencyAmount'] = selectedCurrencyAmount;
        currencies['convertedCurrency'] = convertedCurrency;
        return currencies;
    }
    function displayResults() {
        var currencies = getCurrencies(), resultLabel = $('.selectedCurrencyDetail');
        var resultDivide = $('.js-convertedCurrencyAmountDivide').find('input[type="text"]').val();
        resultDivide = parseFloat(resultDivide).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
        var resultMultiply = $('.js-convertedCurrencyAmountMultiply').find('input[type="text"]').val();
        resultMultiply = parseFloat(resultMultiply).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
        var conversionRate = parseFloat($('.js-rate').find('input').val()).toFixed(4);
        resultLabel.text(parseFloat(currencies['selectedCurrencyAmount']).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,') + ' ' + currencies['selectedCurrency'] + ' =');
        $('.finalCurrencyDivide .amount').html(resultDivide);
        $('.finalCurrencyDivide .currency').html(currencies['convertedCurrency']);
        $('.finalCurrencyMultiply .amount').html(resultMultiply);
        $('.finalCurrencyMultiply .currency').html(currencies['convertedCurrency']);
        $('.conversion').find('.rate').html(conversionRate);
        $('.js-multiplierDivider input').trigger('change');
    }
    $(document).ready(function () {
        var updateResult = $('.js-updateResult').find('select');
        // Changing any of the select fields that affect the result
        $(updateResult).on('change', function () {
            displayResults();
        });
        //Typing amount of currency needed
        $('.js-resultLabel').find('input[type="text"]').on('propertychange change click keyup keydown input paste', function () {
            displayResults();
        });
    });
})(jQuery);
